import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css"; // Bootstrap 5
import "datatables.net-bs5/css/dataTables.bootstrap5.min.css"; // DataTable Bootstrap 5 Styles
import "datatables.net-responsive-bs5/css/responsive.bootstrap5.min.css"; // DataTable Bootstrap 5 Responsive
import "datatables.net-bs5";
import "datatables.net-responsive-bs5";
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import * as XLSX from "xlsx"; // For exporting to Excel
import Header from "../Header";

const ReplyDoc = () => {
  const tableRef = useRef(null);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const hasEmployeeRole = data?.some(rowData => rowData.Role === 'employee' || rowData.Role === 'manager');

  const id = localStorage.getItem('userId');
  const baseUrl = "https://apiaksharaconnect.aksharafinalytics.in/";  // Base URL for files

  // Fetch data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://apiaksharaconnect.aksharafinalytics.in/ShowReply/${id}`
        );
        if (!response.ok) throw new Error("Network response was not ok");

        const result = await response.json();
        setData(result.data || []);
        console.log(result);
      } catch (error) {
        console.error("Error fetching data:", error);
        setError(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Initialize DataTable
  useEffect(() => {
    if (tableRef.current && data.length > 0) {
      const table = $(tableRef.current).DataTable({
        responsive: true,
        autoWidth: false,
        destroy: true, // Reinitialize on data change
        paging: true, // Enable pagination
        pageLength: 10, // Default number of rows per page
        lengthMenu: [10, 25, 50, 100], // Options for rows per page
        columnDefs: [
          { targets: 0, responsivePriority: 1 }, // Always visible
          { targets: 1, responsivePriority: 2 },
          { targets: 2, responsivePriority: 3 },
          { targets: 3, responsivePriority: 4 },
          { targets: 4, responsivePriority: 5 },// Hidden first
        ],
      });

      return () => {
        table.destroy(); // Cleanup on unmount
      };
    }
  }, [data]);

  // Export to Excel
  const exportToExcel = () => {
    if (data.length === 0) {
      alert("No data to export!");
      return;
    }
    const ws = XLSX.utils.json_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "data");
    XLSX.writeFile(wb, "ReplyDoc_List.xlsx");
  };

  // Function to handle downloading a single file
  const downloadFile = (filePath) => {
    if (!filePath) {
      console.error("File path is not defined");
      return;
    }

    // Prepend base URL if it's a relative path
    const fullUrl = filePath.startsWith("http") ? filePath : `${baseUrl}${filePath}`;
    const a = document.createElement('a');
    a.href = fullUrl;
    a.download = filePath.split('/').pop();  // Get the file name from the URL
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  if (loading) return <div className="text-center mt-4">Loading...</div>;

  return (
    <>
      <Header />
      <div className="container-fluid mt-4">
        <div className="card shadow">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4>Reply Documents <button className="btn btn-primary" onClick={() => navigate('/DocRequest')}>
                Add Doc Request
              </button></h4>
              
            <button className="btn btn-success" onClick={exportToExcel}>
              Export to Excel
            </button>
          </div>
          <div className="card-body">
            {error && <div className="alert alert-danger">{error}</div>}

            {/* Responsive Table */}
            <div className="table-responsive">
              <table
                ref={tableRef}
                className="table table-striped table-bordered display nowrap"
                style={{ width: "100%" }}
              >
                <thead>
                  <tr>
                    <th>S.no</th>                    
                    {hasEmployeeRole && <th>Request By</th>}
                    <th>Remarks</th>
                    <th>User</th>
                    <th>User Remarks</th>                    
                    <th>Documents</th>
                    <th>Date/Time</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.length > 0 ? (
                    data.map((rowData, index) => (
                      <tr key={rowData.id}>
                        <td>{index + 1}</td>
                        {hasEmployeeRole && (
                          <td className="text-danger">{rowData.Role === 'employee' || rowData.Role === 'manager' ? rowData.EmpName || 'N/A' : ''}</td>
                        )}
                        <td>{rowData.request_type || "N/A"}</td>                        
                        <td className="text-primary">{rowData.Name || "N/A"}</td>
                        <td>{rowData.user_remarks || "N/A"}</td>
                        
                        <td>
                          {rowData.file_path ? (
                            <a
                              href={`https://apiaksharaconnect.aksharafinalytics.in/${rowData.file_path}`}
                              download={rowData.file_path || 'N/A'}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <button className="btn btn-warning ms-2 p-1 m-1">
                                <FontAwesomeIcon icon={faDownload} /> Documents
                              </button>
                            </a>
                          ) : (
                            <span>No file available</span>
                          )}
                        </td>
                        <td>{rowData.upload_at || "N/A"}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={hasEmployeeRole ? 7 : 6} className="text-center">
                        No data available
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ReplyDoc;
